import React from 'react';

import { VariantNode } from '@candu-ai/styleguide/types';

export const ComponentsSidebar = {
  Layouts: { label: 'Layouts', anchor: 'components-tab-section-layouts' },
  Typography: { label: 'Typography', anchor: 'components-tab-section-typography' },
  Buttons: { label: 'Buttons', anchor: 'components-tab-section-buttons' },
  Cards: { label: 'Cards', anchor: 'components-tab-section-cards' },
  Media: { label: 'Media', anchor: 'components-tab-section-media' },
  Flows: { label: 'Flows', anchor: 'components-tab-section-flows' },
  Forms: { label: 'Forms', anchor: 'components-tab-section-forms' },
  Checklists: { label: 'Checklists', anchor: 'components-tab-section-checklists' },
  Badges: { label: 'Badges', anchor: 'components-tab-section-badges' },
  Divider: { label: 'Divider', anchor: 'components-tab-section-divider' },
  Embeds: { label: 'Embeds', anchor: 'components-tab-section-embeds' },
  Alerts: { label: 'Alerts', anchor: 'components-tab-section-alerts' },
};

export const componentsSidebarSections = [
  ComponentsSidebar.Layouts,
  ComponentsSidebar.Typography,
  ComponentsSidebar.Buttons,
  ComponentsSidebar.Cards,
  ComponentsSidebar.Media,
  ComponentsSidebar.Flows,
  ComponentsSidebar.Forms,
  ComponentsSidebar.Checklists,
  ComponentsSidebar.Badges,
  ComponentsSidebar.Divider,
  ComponentsSidebar.Embeds,
  ComponentsSidebar.Alerts,
];

/**
 * A section of a component before it has been filtered
 */
export interface ComponentUnfilteredSession {
  label: string;
  anchor?: string;
  styleguideSection?: string;
  ComponentContainer?: React.ElementType;
  styleguide?: {
    section: string;
    Component: (props: { variant: VariantNode }) => JSX.Element;
  };
  builtIn?: {
    label: string;
    Component: (props: any) => JSX.Element;
  }[];
}

export interface ComponentFilteredSession extends ComponentUnfilteredSession {
  variants?: VariantNode[];
}
